import { useEffect, useRef } from "react";
import { useExport } from "@/context/ExportContext";

// BoardPack itself is rendered by BoardPackExportHost (mounted once at the App
// level) and portaled in here via registerVisibleSlot. This lets an in-flight
// export survive navigating away from /board-pack instead of being unmounted.
const BoardPackPage = () => {
  const slotRef = useRef(null);
  const { registerVisibleSlot } = useExport();

  useEffect(() => {
    registerVisibleSlot(slotRef.current);
    return () => registerVisibleSlot(null);
  }, [registerVisibleSlot]);

  return <div ref={slotRef} className="h-full min-h-0" style={{ width: "100%" }} />;
};

export default BoardPackPage;
